import React from 'react';
import Header from './Header';
import Footer from './Footer'

const PrivacyPolicy = () => {
    return (
        <>
        <Header/>
        <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100">
            <div className="bg-gradient-to-r from-slate-800 to-slate-700 text-white py-20">
                <div className="max-w-7xl mx-auto px-6">
                    <h1 className="text-5xl font-bold mb-4">Privacy Policy</h1>
                    <p className="text-xl text-slate-200">How we protect and handle your data</p>
                </div>
            </div>

            <div className="max-w-7xl mx-auto px-6 py-16">
                <div className="bg-white rounded-xl shadow-lg p-12 text-center">
                    <h2 className="text-3xl font-bold text-slate-800 mb-4">Privacy Policy</h2>
                    <p className="text-slate-600 text-lg">We are committed to protecting your privacy and ensuring the security of your personal and financial information in accordance with industry standards.</p>
                </div>
            </div>
        </div>
        <Footer/>
        </>
    );
};

export default PrivacyPolicy;
